
import { Button } from "@/components/ui/button";

interface DashboardHeaderProps {
  onLogout: () => void;
}

export const DashboardHeader = ({ onLogout }: DashboardHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-3xl font-bold">Alfie Dashboard</h1>
      <Button
        variant="outline"
        onClick={onLogout}
      >
        Logout
      </Button>
    </div>
  );
};
